import { render, staticRenderFns } from "./newcoupon.vue?vue&type=template&id=e96de91c&scoped=true&"
import script from "./newcoupon.vue?vue&type=script&lang=js&"
export * from "./newcoupon.vue?vue&type=script&lang=js&"
import style0 from "./newcoupon.vue?vue&type=style&index=0&id=e96de91c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96de91c",
  null
  
)

export default component.exports